<template>
  <nav class="navbar navbar-expand-md carang_bg fixed-top">
    <a class="logo-title navbar-brand text-white" href="/dashboard">
      <img
        class="kslab-icon"
        src="../../public/img/logo/white-logo.png"
        alt="kslab"
      />
      EV Monitoring
    </a>
    <div class="ver-box">
      <div>v 2.1.1</div>
    </div>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarNav"
      aria-controls="navbarNav"
      aria-expanded="false"
      aria-label="Toggle navigation"
      @click="navShowHide"
    >
      <i class="fas fa-bars text-white"></i>
    </button>

    <div
      class="collapse navbar-collapse ml-md-4"
      id="navbarNav"
      :class="{ show: isMobile }"
    >
      <!-- 모바일 드롭다운 메뉴 내 border -->
      <div class="d-block d-lg-none d-md-none border-top"></div>

      <div class="form-box" :class="{ 'mobile-menu-box': isMobile, 'web-menu-box': !isMobile }">
        <b class="form-label"> Auto Modal </b>
        <b-form-checkbox
          switch
          v-model="autoChecked"
          @change="autoModalCtrl()"
          class="mr-n2"
        >
        </b-form-checkbox>
      </div>

      <div class="form-box" :class="{ 'mobile-menu-box': isMobile, 'web-menu-box': !isMobile }">
        <b class="form-label"> Location </b>
        <b-form-select
          :class="{ 'mobile-select-form': isMobile }"
          v-model="locationText"
          :options="locationOpt"
          @change="locationCtrl()"
          size="sm"
        >
        </b-form-select>
      </div>

      <div class="form-box" :class="{ 'mobile-menu-box': isMobile, 'web-menu-box': !isMobile }">
        <b class="form-label"> EV Monitoring </b>
          <b-form-input
            :class="{ 'mobile-input-form': isMobile, 'web-input-form': !isMobile  }"
            placeholder="단말기ID 조회"
            v-model="id"
            size="sm"
          >
          </b-form-input>
      
          <b-button
            class="form-btn-item"
            variant="none"
            @click="monitorCtrl(id)" 
          >
            <i class="fa-solid fa-magnifying-glass" style="color: #ffffff;"></i>
          </b-button>
      
          <b-button
            type="reset"
            class="form-btn-item"
            variant="none"
            @click="resetId()" 
          >
            <i class="fa-solid fa-trash" style="color: #ffffff;"></i>
          </b-button>
      </div>

      <!-- 모바일 드롭다운 메뉴 내 border -->
      <div class="d-block d-lg-none d-md-none border-top"></div>

      <ul
        v-if="$store.getters.userAuth === 'admin'"
        class="navbar-nav"
        :class="{ 'mobile-menu-box': isMobile }"
      >
        <li class="nav-item">
          <router-link to="/company" class="nav-link text-white">
            <i class="fas fa-building align-middle"></i> 회사
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/car" class="nav-link text-white">
            <i class="fas fa-car align-middle"></i> 차량
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/user" class="nav-link text-white">
            <i class="fas fa-user align-middle"></i> 운전자
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/term" class="nav-link text-white">
            <i class="fas fa-tools align-middle"></i> 단말기
          </router-link>
        </li>
        <!-- <li class="nav-item">
          <router-link to="/parts" class="nav-link text-white">
            <i class="fas fa-clipboard-list align-middle"></i> 소모품
          </router-link>
        </li> -->
        <li class="nav-item">
          <router-link to="/member" class="nav-link text-white">
            <i class="fas fa-user-friends align-middle"></i> 계정
          </router-link>
        </li>
        <!-- <li class="nav-item">
          <router-link to="/lbsmem" class="nav-link text-white">
            <i class="fas fa-user-friends align-middle"></i> LBS 접근
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/lbsterm" class="nav-link text-white">
            <i class="fas fa-user-friends align-middle"></i> LBS 수집
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/lbslog" class="nav-link text-white">
            <i class="fas fa-user-friends align-middle"></i> LBS 접속
          </router-link>
        </li> -->
      </ul>

      <div :class="{ 'mobile-link-box': isMobile, 'web-link-box': !isMobile }">
        <span
          class="navbar-text text-white small d-none d-md-block"
          :class="{ 'd-block': isMobile, 'mobile-link-item': isMobile }"
        >
          <a class="homepage_btn" href="http://www.kslabco.com">
            <i class="fa-solid fa-house-chimney"></i>
            KS LAB 홈페이지 바로가기
          </a>
        </span>
        <router-link
          to="/logout"
          class="btn btn-xs btn-outline-light small d-none d-md-block ml-2"
          :class="{ 'd-block': isMobile, 'mobile-link-item': isMobile }"
        >
          로그아웃
        </router-link>
      </div>
    </div>
  </nav>
</template>

<script>
import store from "@/store";

export default {
  name: "Header",
  data() {
    return {
      isMobile: false,
      isAdmin: false,
      autoChecked: false,

      locationText: "제주",
      locationOpt: [
        { value: null, text: "선택" },
        { value: "제주", text: "제주" },
        { value: "경기", text: "경기" }
      ],

      id: null
    };
  },

  methods: {
    navShowHide() {
      this.isMobile = !this.isMobile;
    },

    autoModalCtrl() {
      store.dispatch("autoModalCtrl");
    },

    locationCtrl() {
      store.dispatch("locationCtrl", { location: this.locationText });
    },

    monitorCtrl() {
      if(this.id == null || this.id == "") {
        console.log('단말기 ID를 입력해주세요1')
      } else {
        store.dispatch("monitorCtrl", { id:  this.id });
      }
    },

    resetId() {
      this.id = null
    }

  },
  
  computed: {
    location() {
      return store.getters.locationState;
    }
  },

  watch: {
    location(value) {
      if(value == null) {
        this.locationText = null
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.logo-title {
  font-weight: 600;
}

.kslab-icon {
  width: auto;
  height: auto;
  max-width: 35px;
  margin-right: 10px;
}

.ver-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
}

.homepage_btn {
  color: white;
  font-size: 12px;
}

.nav-item {
  margin-right: 0.5rem;
  margin-left: 0.5rem;
  border-bottom: 1px solid #13a3f3;
  .fab,
  .fas {
    margin-right: 0.2rem;
    font-size: 0.8rem;
  }
}

.nav-link {
  font-size: 0.9rem;
  border-bottom: 1px solid #13a3f3;
}

.router-link-active {
  // border-bottom: 1px solid #fff;
  background-color: #69c0f0;
}

.form-box {
  margin-right: 15px;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.form-label {
  color: #fff;
  margin-right: 7px;
}

.mobile-menu-box {
  margin-top: 10px;
  margin-bottom: 10px;
}

.web-menu-box {
  border-left: 1px solid #fff;
  padding-left: 10px;
} 

.mobile-link-box {
  border-top: solid 0.5px #fff;

  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  color: #fff;
}

.web-link-box {
  margin-left: auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  color: #fff;
}

.web-input-form {
  width: 50%;
}

.mobile-link-item {
  margin-top: 7px;

}

.mobile-select-form {
  width: 20%;
}

.mobile-input-form {
  width: 50%;
}

.form-btn-item {
  padding: 2px 2px 2px 15px;
}
</style>
